import { Trash2, Image as ImageIcon, Loader2 } from "lucide-react";
import { STATUS_COLORS, STATUS_LABEL } from "./leadStatus";

function LoadingRow() {
  return (
    <tr>
      <td colSpan={7} className="text-center py-16">
        <Loader2 className="inline animate-spin text-[#FF5A00]" />
      </td>
    </tr>
  );
}

function EmptyRow() {
  return (
    <tr>
      <td colSpan={7} className="text-center py-16 text-neutral-500">
        Aucune demande pour ce filtre
      </td>
    </tr>
  );
}

function LeadRow({ lead: l, onOpen, onDelete }) {
  return (
    <tr
      onClick={() => onOpen(l.id)}
      data-testid={`admin-lead-row-${l.id}`}
      className="border-b border-white/5 hover:bg-white/[0.02] cursor-pointer transition-colors"
    >
      <td className="px-5 py-4">
        <div className="font-medium text-white">{l.name}</div>
        <div className="text-xs text-neutral-500 flex items-center gap-3 mt-0.5">
          <span>{l.email}</span>
          {l.has_photo && (
            <span className="inline-flex items-center gap-1 text-[#FF5A00]">
              <ImageIcon size={11} /> photo
            </span>
          )}
        </div>
      </td>
      <td className="px-5 py-4 text-neutral-300 hidden md:table-cell">{l.city}</td>
      <td className="px-5 py-4 text-neutral-400 hidden lg:table-cell">
        {l.surface ? `${l.surface} m²` : "—"}
      </td>
      <td className="px-5 py-4 text-neutral-400 hidden lg:table-cell">
        {l.estimated_min
          ? `${l.estimated_min.toLocaleString("fr-FR")} – ${l.estimated_max.toLocaleString("fr-FR")} €`
          : "—"}
      </td>
      <td className="px-5 py-4 text-neutral-500 hidden md:table-cell text-xs">
        {new Date(l.created_at).toLocaleDateString("fr-FR", {
          day: "2-digit",
          month: "short",
        })}
      </td>
      <td className="px-5 py-4">
        <span
          className={`text-xs px-2.5 py-1 rounded-full ${STATUS_COLORS[l.status] || STATUS_COLORS.new}`}
        >
          {STATUS_LABEL[l.status] || l.status}
        </span>
      </td>
      <td className="px-5 py-4 text-right">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDelete(l.id);
          }}
          data-testid={`admin-delete-${l.id}`}
          className="text-neutral-500 hover:text-red-400 transition-colors"
        >
          <Trash2 size={15} />
        </button>
      </td>
    </tr>
  );
}

export function LeadsTable({ loading, leads, onOpen, onDelete }) {
  let body;
  if (loading) body = <LoadingRow />;
  else if (leads.length === 0) body = <EmptyRow />;
  else
    body = leads.map((l) => (
      <LeadRow key={l.id} lead={l} onOpen={onOpen} onDelete={onDelete} />
    ));

  return (
    <div className="rounded-2xl border border-white/10 overflow-hidden bg-[#0a0a0a]">
      <table className="w-full text-sm">
        <thead className="bg-white/[0.02] border-b border-white/5">
          <tr className="text-left text-xs uppercase tracking-wider text-neutral-500">
            <th className="px-5 py-4">Client</th>
            <th className="px-5 py-4 hidden md:table-cell">Ville</th>
            <th className="px-5 py-4 hidden lg:table-cell">Surface</th>
            <th className="px-5 py-4 hidden lg:table-cell">Budget</th>
            <th className="px-5 py-4 hidden md:table-cell">Date</th>
            <th className="px-5 py-4">Statut</th>
            <th className="px-5 py-4"></th>
          </tr>
        </thead>
        <tbody data-testid="admin-leads-table">{body}</tbody>
      </table>
    </div>
  );
}
